import { BIRDVIEW_TILE_ROW_CAROUSEL_MAX_WIDTH } from './BirdviewTileRow.constants'

export function getBirdviewTileRowItemId(item) {
  return item.id
}

export function checkIsBirdviewTileRowCarousel(width) {
  return width <= BIRDVIEW_TILE_ROW_CAROUSEL_MAX_WIDTH
}
